

















































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { getSignatureServer, performanceServer, siteManagementServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class WorkOrderDetailsDialog extends Vue {
  visible: any = false;
  row: any = {};
  scrollbar = true;
  validatorCodeUrl = ''; // 签名图片路径
  a = '（<35ppm）';
  b = '（<10%）';
  c = '（<18%-21%）';

  newDataForm: any = {};
  imgPath: any = 'data:image/jpeg;base64,';
  private URLPath: any = '';
  CellGroupList: any = [];
  AnalysisLimitSpaceList: any = [];
  newAnalysisList: any = [];
  measureTemporaryElectrolList: any = [];
  electroEquipListList: any = [];
  private loading: any = false;
  private applyStaffSignature: any = '';

  // 表单数据
  private formData: any = {
    applyId: '',
    applyStaffId: '',
    applyStaffName: '',
    approvalFlowExampleId: '',
    controlsRecord: [],
    finishFlag: false,
    finishTime: '',
    id: '',
    processLog: [
      {
        actionList: [],
        afterFlowNode: '',
        afterFlowNodeName: '',
        beforeFlowNode: '',
        beforeFlowNodeName: '',
        endTime: '',
        flowExampleId: '',
        id: '',
        memberList: [
          {
            objId: '',
            objName: '',
            type: '',
          },
        ],
        operation: '',
        operationName: '',
        startTime: '',
        withdraw: false,
      },
    ],
    safetyMeasureRecord: [],
    safetyMeasureAnnexData: [],
    taskEndTime: '',
    taskStartTime: '',
    taskUnit: '',
    type: '',
    workOrder: '',
  };
  private safetyDisclosureArr: any = [];
  private discloserArr: any = [];

  private processLogData: any = [
    {
      beforeFlowNodeName: '负责人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '审核人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '批准人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '验收评估',
      actionList: [],
    },
  ];
  private otherSafetyMeasure: any = '';
  private riskIdentifyValue: any = '';
  private relevanceOtherValue: any = '';
  private directorUnitNameValue: any = '';
  private projectNameValue: any = '';

  created() {}

  mounted() {}

  showDialog(row: any) {
    this.row = row;
    this.URLPath = publishObjectPath.imgPathWater;
    this.$nextTick(() => {
      this.getData(this.row);
    });

    this.visible = true;
  }

  getData(data: any) {
    this.loading = true;
    // 通过主键查询单条数据
    siteManagementServer.getSingleSiteManagementData(data.id).then((res: any) => {
      this.loading = false;
      // 中部动态内容处理--开始
      res.data.processLog.splice(0, 1);
      if (res.data.controlsRecord && res.data.controlsRecord.length > 0) {
        res.data.controlsRecord.forEach((r: any, index: any) => {
          if (r.title.indexOf('签名') !== -1) {
            // this.newDataForm.title = item.title;
            // this.getValidatorCode(item.value);
            res.data.controlsRecord.splice(index, 1);
          }
        });

        res.data.controlsRecord.map((item: any, index: any) => {
          if (item.controlsType === 'Radio' || item.controlsType === 'Text' || item.controlsType === 'Input') {
            item.value = item.value;
          }
          if (item.controlsType === 'ChoiceText') {
            let strValue: any = '';
            if (item.value) {
              if (item.value.choice && item.value.choice.length) {
                item.value.choice.forEach((item: any) => {
                  strValue += item.label + '、';
                });
              }
              if (item.value.text) {
                strValue += item.value.text;
              }
            }
            item.value = strValue;
          }

          if (item.controlsType == 'AnalysisLimitSpace') {
            console.log(item, 'AnalysisLimitSpace');
            item.value.forEach(async (i: any) => {
              const resInner: any = await this.getSignatureData(i.sign);
              i.signature = resInner && resInner.signature ? resInner.signature : '';
              this.AnalysisLimitSpaceList.push(i);
            });
            // setTimeout(() => {
            //   this.AnalysisLimitSpaceList = item.value;
            // }, 5000);

            res.data.controlsRecord.splice(index, 1);
          }
          if (item.controlsType == 'CellGroup') {
            this.CellGroupList = item.value;
          }

          if (item.controlsType === 'ContactPerson' || item.controlsType === 'ContactPersonMore') {
            const newArr: any = [];
            item.value.map((itemInner: any) => {
              newArr.push(itemInner.name);
            });
            item.value = newArr.join(', ');
          }

          if (item.controlsType === 'Location') {
            if (item.value && item.value !== '' && item.value !== undefined && item.value !== null) {
              if (this.isJson(item.value)) {
                item.value = JSON.parse(item.value).info;
              } else {
                item.value = item.value.info;
              }
            } else {
              item.value = item.value;
            }
          }
        });
      }

      res.data.processLog.map((r: any, index1: any) => {
        r.actionList.forEach(async (i: any) => {
          const resInner: any = await this.getSignatureData(i.signature);
          i.deptName = resInner && resInner.deptName ? resInner.deptName : '';
          i.postNames = resInner && resInner.postNames ? resInner.postNames : '';
          i.signature = resInner && resInner.signature ? resInner.signature : '';
        });
      });

      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.title === '分析项目') {
          res.data.controlsRecord.splice(index, 1);
        }
        if (r.title === '分析数据') {
          this.newAnalysisList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-measureTemporaryElectro') {
          this.measureTemporaryElectrolList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-electroEquipList') {
          this.electroEquipListList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-otherSafeStep') {
          this.otherSafetyMeasure = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-riskIdentify') {
          if (r.value) {
            this.riskIdentifyValue = r.value;
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      // console.log(this.riskIdentifyValue,'this.riskIdentifyValue');
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'WorkTicket-relevanceOther') {
          console.log(r, 'r');
          if (r.value && r.value.length) {
            r.value.forEach((relation: any) => {
              this.relevanceOtherValue += relation.workOrder + '  ';
            });
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-directorUnitName') {
          this.directorUnitNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-projectName') {
          this.projectNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      this.formData = res.data;
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.actionList && item.actionList.length > 0) {
          item.actionList.forEach((img: any) => {
            this.$set(img, 'imgArr', []);
            if (img.images) {
              this.getSysFile(img);
            }
          });
        }
      });
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.beforeFlowNodeName === '安全交底人') {
          this.safetyDisclosureArr = item.actionList;
          res.data.processLog.splice(index, 1);
        }
      });
      res.data.processLog.forEach((item: any, index: any) => {
        if (item.beforeFlowNodeName === '接受交底人') {
          this.discloserArr = item.actionList;
          res.data.processLog.splice(index, 1);
        }
      });
      this.processLogData.forEach((item: any, index: any) => {
        if (res.data.processLog[index]) {
          this.processLogData[index].actionList = res.data.processLog[index].actionList;
        } else {
          this.processLogData[index].actionList = [];
        }
      });
      this.getStaffSignatureByStaffId();

      // 中部动态内容处理--结束
    });
  }
  // 获取签名图片 根据人员id
  private getStaffSignatureByStaffId() {
    getSignatureServer.getStaffSignatureByStaffId(this.formData.applyStaffId).then((res: any) => {
      if (res.code === '200') {
        if (!res.data) {
          // this.$message.warning('当前人员暂无签名');
        } else {
          this.applyStaffSignature = res.data.signature;
        }
      } else {
      }
    });
  }

  private getSysFile(data: any) {
    performanceServer.getSysFile(data.images).then((res: any) => {
      if (res.code === '200' && res.data.length > 0) {
        data.imgArr = res.data;
      }
    });
  }

  // 判断是否为json格式
  isJson(data: any) {
    if (typeof data === 'string') {
      try {
        const obj: any = JSON.parse(data);
        if (typeof obj === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  async getValidatorInnerCode(id: any) {
    if (id) {
      const res: any = await performanceServer.getValidatorCode(id);
      return res.data.signature;
    } else {
      return '';
    }
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  // 时间格式处理--年-月-日-时-分
  timeProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return SY + '年' + SM + '月' + SD + '日' + Sh + '时' + Sm + '分';
  }

  // 时间格式处理--时-分
  timeTwoProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return Sh + ':' + Sm;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.newDataForm = {};
    this.validatorCodeUrl = '';
    // this.showWhatFlag = 1;
  }

  /**
   * 导出
   * */
  // onExport() {
  //   const obj: any = {
  //     type: this.row.type,
  //     // applyStaffName: this.formData.applyStaffName,
  //     workOrder: this.formData.workOrder,
  //   };
  //   const exportContainer: any = document.getElementById('imageWrapper');
  //   downloadPDF(exportContainer, obj);
  // }

  // download(imgUrl: any, kh: any) {
  //   this.getUrlBase64(imgUrl, kh).then(base64 => {
  //     const link: any = document.createElement('a');
  //     link.href = base64;
  //     link.download = `${this.row.type} - ${this.formData.applyStaffName} -  ${this.formData.workOrder}.jpg`;
  //     link.click();
  //   });
  // }
  getUrlBase64(url: any, kh: any) {
    return new Promise(resolve => {
      let canvas: any = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = '*'; // 允许跨域
      img.src = url;
      img.onload = () => {
        // eslint-disable-next-line prefer-destructuring
        canvas.height = kh[1];
        // eslint-disable-next-line prefer-destructuring
        canvas.width = kh[0];
        ctx.drawImage(img, 0, 0, kh[0], kh[1]);
        const dataURL = canvas.toDataURL('image/png');
        canvas = null;
        resolve(dataURL);
      };
    });
  }

  imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }
}
